import {ButtonState} from '@fantasmagames/core/src/display/Button';
import {SpriteButton} from '@fantasmagames/core/src/display/SpriteButton';
import {SpriteGraphics} from '@fantasmagames/core/src/display/SpriteGraphics';
import TextStyleOptions = PIXI.TextStyleOptions;

export class GenericButton extends SpriteButton {
	protected _textObject: PIXI.Text;
	protected _id: number;
	protected _clicked: boolean = false;

	protected _textContainer: PIXI.Container;
	protected _buttonContainer: PIXI.Container;

	protected _hiddenInputGraphics: PIXI.Sprite;

	protected _textStyle: TextStyleOptions;
	protected _extraData: any;

	constructor(callback?: Function, textStyle?: TextStyleOptions) {
		super(callback);

		this._buttonContainer = new PIXI.Container();
		this._textContainer = new PIXI.Container();

		this._buttonContainer.interactiveChildren = false;
		this._textContainer.interactiveChildren = false;

		this._hiddenInputGraphics = SpriteGraphics.makeHiddenRectangle(100, 100);
		this._hiddenInputGraphics.anchor.set(0.5);

		this.addChild(this._buttonContainer);
		this.addChild(this._textContainer);
		this.addChild(this._hiddenInputGraphics);

		this.setupText(textStyle);
	}

	public setSelected(): void {
		this.setState(ButtonState.DOWN);
		if (this._callback) {
			this._callback(false);
		}
	}

	public resetState(): void {
		this._clicked = false;
		this.setState(ButtonState.UP);
	}

	public forceClicked(): void {
		this._clicked = true;
	}

	public changeText(newText: string): void {
		this._textObject.text = newText;
		this.updateTexts();
	}

	public onMouseUp(): void {
		if (this._state === ButtonState.DOWN) {
			this._clicked = true;
		} else {
			this.setState(ButtonState.UP);
		}
	}

	public scaleTextToFitContainer(scalar: number = 1): void {
		this._textContainer.scale.set(1);
		if (this._textContainer.width > this._buttonContainer.width * scalar) {
			const procentage = (this._buttonContainer.width * scalar) / this._textContainer.width;
			this._textObject.scale.set(procentage);
		}
	}

	protected setState(value: ButtonState): void {
		if (this._state !== value) {
			this._state = value;

			if (this._buttonContainer) {
				this.cleanFrame();
			}
			this.updateFrame();
		}
	}

	protected updateFrame(): void {
		if (this._frames[this._state]) {
			this._buttonContainer.addChild(this._frames[this._state]);
			this._hiddenInputGraphics.width = this._frames[this._state].width;
			this._hiddenInputGraphics.height = this._frames[this._state].height;
		}
	}

	protected cleanFrame(): void {
		this._buttonContainer.removeChildren();
	}

	protected updateTexts(): void {
		if (this._textObject) {
			this._textObject.x = this.width / 2;
			this._textObject.y = this.height / 2;

			this._textContainer.removeChild(this._textObject);
			this._textContainer.addChild(this._textObject);
		}
	}

	protected setupText(textStyle?: TextStyleOptions): void {
		this._textObject = new PIXI.Text('', textStyle);
		this._textObject.anchor.set(0.5);
	}

	protected onMouseOver(): void {
		if (!(this._state === ButtonState.DOWN)) {
			this._over = true;
			this.setState(ButtonState.OVER);
		}
	}

	protected onClick(): void {
		if (!(this._state === ButtonState.DOWN)) {
			this.setState(ButtonState.OVER);
		}

		if (this._callback && this._state === ButtonState.DOWN) {
			this._callback(true);
		}
	}

	protected onMouseOut(): void {
		this._mouseOutCallback && this._mouseOutCallback();
		if (!(this._state === ButtonState.DOWN) || !this._clicked) {
			this._over = false;
			this.setState(ButtonState.UP);
		}
	}

	protected onMouseDown(): void {
		this.setState(ButtonState.DOWN);
		this._tapDownCallback && this._tapDownCallback();
		// this._clicked = true;
	}

	public set id(v: number) {
		this._id = v;
	}

	public get id(): number {
		return this._id;
	}

	public set extraData(data: any) {
		this._extraData = data;
	}

	public get extraData(): any {
		return this._extraData;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/GenericButton.ts